import { Box } from '@mui/material';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledBingoPopProducts = styled(Box)`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  height: 96px;
  padding: 5px;
  align-items: center;

  .types-divider {
    border-right-width: 2px;
    border-color: #1b6de317;
    width: 0px;
  }

  @media (min-width: ${breakpoints.tablet}) {
    padding: 17px 13px;
    max-height: 153px;
  }
`;

interface IStyledBingoPopMainProductProps {
  textColor: string;
}

export const StyledSubContainer = styled.div`
  width: 59%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
  align-content: center;
`;

export const StyledBingoPopMainProduct = styled.div<IStyledBingoPopMainProductProps>`
  width: 32.4%;
  display: flex;
  flex-direction: column;
  align-items: center !important;

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    width: auto;
    aspect-ratio: 1/1;

    .image {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 24px;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: 100%;

    &__stroked {
      font-size: 12px;
      margin-top: -7px;
      text-decoration: line-through;
      text-decoration-color: #d92701;
      color: #a5b9d2;
      font-weight: 400;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .image-container {
      height: 52px;
      width: auto;
      aspect-ratio: 1/1;
    }
    
    .quantity {
      font-size: 32px;
      
      &__stroked {
        font-size: 14px;
      }
    }
  }
`;

interface IStyledBingoPopSubProductProps {
  textColor: string;
}

export const StyledBingoPopSubProduct = styled.div<IStyledBingoPopSubProductProps>`
  display: flex;
  gap: 2px;
  justify-content: center;
  flex-direction: row;
  align-items: center;

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    width: 28px;
    height: auto;
    margin-left: 5px;

    .image {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 18px;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: calc(100% - 24px);
  }
  
  @media (min-width: ${breakpoints.tablet}) {
    .image-container {
      width: 36px;
    }
  }
`;
